import request from '@/api/request'

/**
 * 分页查询班级列表
 *
 * @param {*} data
 * @return {*}
 */

export const getPageList = data => {
  return request({
    url: 'product/adm/sku/page',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 添加班级
 *
 * @param {*} data
 * @return {*}
 */

export const addClass = data => {
  return request({
    url: 'product/adm/sku/add',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 编辑班级
 *
 * @param {*} data
 * @return {*}
 */

export const updateClass = data => {
  return request({
    url: 'product/adm/sku/update',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 班级批量添加课程
 *
 * @param {*} data
 * @return {*}
 */

export const addClassCourse = data => {
  return request({
    url: 'product/adm/skuCourse/add',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 班级删除课程
 *
 * @param {*} data
 * @return {*}
 */

export const delClassCourse = data => {
  return request({
    url: 'product/adm/skuCourse/del',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 班级批量删除课程
 *
 * @param {*} data
 * @return {*}
 */

export const delClassCourses = data => {
  return request({
    url: 'product/adm/skuCourse/dels',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询班级课程列表
 *
 * @param {*} data
 * @return {*}
 */

export const getClassCourseList = data => {
  return request({
    url: 'product/adm/skuCourse/page',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询公开课列表
 *
 * @param {*} data
 * @return {*}
 */

export const getPublicClassList = data => {
  return request({
    url: 'product/adm/skuLesperiod/page',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 添加公开课
 *
 * @param {*} data
 * @return {*}
 */

export const addPublicClass = data => {
  return request({
    url: 'product/adm/skuLesperiod/add',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 编辑公开课
 *
 * @param {*} data
 * @return {*}
 */

export const updatePublicClass = data => {
  return request({
    url: 'product/adm/skuLesperiod/update',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 删除公开课
 *
 * @param {*} data
 * @return {*}
 */

export const delPublicClass = data => {
  return request({
    url: 'product/adm/skuLesperiod/del',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询班级用户列表
 *
 * @param {*} data
 * @return {*}
 */

export const getClassStudentList = data => {
  return request({
    url: 'product/adm/userSku/page',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 分页查询班级用户列表
 *
 * @param {*} data
 * @return {*}
 */

export const queryStudentStatus = data => {
  return request({
    url: 'product/adm/userSku/listUserIdInSku',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 添加班级学员
 *
 * @param {*} data
 * @return {*}
 */

export const addClassStudent = data => {
  return request({
    url: 'product/adm/userSku/add',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 批量添加班级学员
 *
 * @param {*} data
 * @return {*}
 */
export const addsClassStudent = data => {
  return request({
    url: 'product/adm/userSku/adds',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * product/adm/userSku/update
 *
 * @param {*} data
 * @return {*}
 */
export const userSkuupdate = data => {
  return request({
    url: 'product/adm/userSku/update',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 删除班级学员
 *
 * @param {*} data
 * @return {*}
 */

export const delClassStudent = data => {
  return request({
    url: 'product/adm/userSku/del',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 批量删除班级学员
 *
 * @param {*} data
 * @return {*}
 */

export const delClassStudents = data => {
  return request({
    url: 'product/adm/userSku/dels',
    method: 'post',
    type: 'json',
    data,
  })
}

/**
 * 更新班级信息
 *
 * @param {*} data
 * @return {*}
 */
export const skuupdate = data => {
  return request({
    url: 'product/adm/sku/update',
    method: 'post',
    type: 'json',
    data,
  })
}

// ---------------------

/**
 * 套打合格证
 * @param page
 * @param limit
 */
export const printQualified = (data) => {
  return request({
    url: 'product/adm/userSku/printQualified',
    data,
    method: 'post',
    type: "json"
  })
}

/**
 * 面授班级分类列表-》获取证书
 */
export const getCertificateInfo = (params) => {
  return request({
    url: 'radioweb/adm/certificateInfo/getList',
    params,
    method: 'get',
    type: 'json'
  })
}

// 分页查询班级证书列表
export const skuCertificatepage = (data) => {
  return request({
    url: '/product/adm/skuCertificate/page',
    method: 'post',
    data,
    type: "json"
  })
}

// 更新班级证书
export const skuCertificateupdate = (data) => {
  return request({
    url: 'product/adm/skuCertificate/update',
    method: 'post',
    data,
    type: "json"
  })
}

/**
 * 批量删除结业证
 * @param page
 * @param limit
 */
export const delGraduation = (data) => {
  return request({
    url: 'product/adm/userSku/delGraduations',
    data,
    type: 'json',
    method: 'post'
  })
}

/**
 * 重新生成结业证
 * @param page
 * @param limit
 */
export const awardGraduationAgain = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/awardGraduationAgain',
    data,
    method: 'post'
  })
}

/**
 * 结业证
 */
export const exportBatchGraduation = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportBatchGraduation',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}

/**
 * 合格证
 */
export const exportBatchCertificate = (data) => {
  return request({
    url: 'radioweb/adm/classStudent/exportBatchCertificate',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}


/**
 * 导出全部结业证
 */
export const exportAllQualified = (data) => {
  return request({
    url: 'product/adm/userSku/exportAllQualified',
    data,
    responseType: "arraybuffer",
    method: 'post'
  })
}


/**
 * 面授班级分类列表-》删除合格证
 */
export const delCertificate = (data) => {
  return request({
    url: 'product/adm/userSku/delCertificates',
    data,
    method: 'post',
    type: 'json'
  })
}


/**
 * 面授班级分类列表-》批量颁发合格证
 */
export const awardQualifieds = (data) => {
  return request({
    url: 'product/adm/userSku/awardQualifieds',
    data,
    method: 'post',
    type: "json"
  })
}

/**
 * 面授班级分类列表-》全部颁发合格证
 */
export const awardQualified = (data) => {
  return request({
    url: 'product/adm/userSku/awardQualified',
    method: 'post',
    data,
    type: "json"
  })
}

/**
 * 面授班级分类列表-》删除全部合格证
 */
export const delAllCertificate = (data) => {
  return request({
    url: 'product/adm/userSku/delAllCertificate',
    data,
    method: 'post',
    type: "json"
  })
}


/**
 * 面授班级分类列表-》删除全部结业证
 */
export const delAllGraduation = (data) => {
  return request({
    url: 'product/adm/userSku/delAllGraduation',
    data,
    method: 'post',
    type: "json"
  })
}

/**
 * 增加套打次数
 */
export const addPlayTimes = (data) => {
  return request({
    url: 'product/adm/userSku/updateQualifiedPrintNum',
    data,
    type: 'json',
    method: 'post'
  })
}

// 颁发学员证书
export const awardQualifiedOne = (data) => {
  return request({
    url: 'product/adm/userSku/awardQualifiedOne',
    method: 'post',
    data,
    type: "json"
  })
}
//保存证书
export const updateAward = (data) => {
  return request({
    url: 'product/adm/userSku/updateAward',
    method: 'post',
    data,
    type: "json"
  })
}
//保存证书
export const printQualified1 = (data) => {
  return request({
    url: '/product/adm/userSkuCertificate/print',
    method: 'post',
    data,
    type: "json"
  })
}
//保存证书
export const addPlayTimes1 = (data) => {
  return request({
    url: '/product/adm/userSkuCertificate/updateQualifiedPrintNum',
    method: 'post',
    data,
    type: "json"
  })
}
